import { render, staticRenderFns } from "./lazyblock_projects.vue?vue&type=template&id=547de9aa&scoped=true"
import script from "./lazyblock_projects.vue?vue&type=script&lang=js"
export * from "./lazyblock_projects.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_projects.vue?vue&type=style&index=0&id=547de9aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547de9aa",
  null
  
)

export default component.exports